export const CarWashSelectedSkeleton = () => {
  return (
    <div className="rounded animate-fade-in-up bg-popupLight dark:bg-popupDark p-6 relative w-[90%] mt-5 mb-10 shadow-lg mx-auto">
      <div className="absolute top-6 left-6 w-10 h-10 rounded-full bg-gray-300 dark:bg-gray-700 animate-pulse" />
      <div className="flex flex-col md:flex-row gap-8 max-w-5xl mx-auto">
        <div className="rounded-lg shadow-sm max-w-sm w-full h-64 bg-gray-300 dark:bg-gray-700 animate-pulse" />
        <div className="flex flex-col justify-start flex-1 gap-6">
          <div className="h-8 w-1/2 bg-gray-300 dark:bg-gray-700 rounded-md animate-pulse" />
          <div className="h-20 w-full bg-gray-300 dark:bg-gray-700 rounded-md animate-pulse" />
          <div className="h-24 w-full bg-gray-300 dark:bg-gray-700 rounded-md animate-pulse" />
          <div className="h-10 w-32 bg-gray-300 dark:bg-gray-700 rounded-md animate-pulse" />
          <div className="h-12 w-56 bg-gray-300 dark:bg-gray-700 rounded-md animate-pulse" />
          <div className="h-12 w-full bg-gray-300 dark:bg-gray-700 rounded-md animate-pulse" />
        </div>
      </div>
    </div>
  );
};
